import React, { FC, useState } from 'react';
import { MessageList } from 'components/common/message-list';
import { CreateMessageModal } from 'components';
import { Service } from 'types';

type ServiceSMSProps = {
  job?: Service;
};

export const ServiceSMS: FC<ServiceSMSProps> = (props) => {
  const { job } = props;
  const [isNewSmsModalOpen, setIsNewSmsModalOpen] = useState<boolean>();

  if (!job) return null;

  return (
    <>
      <MessageList.$
        for="job"
        id={job.ID.toString()}
        messageType="sms"
        onAdd={() => setIsNewSmsModalOpen(true)}
        triggerRefetch={isNewSmsModalOpen === false}
      />
      <CreateMessageModal.$
        hasNotification
        messageType="sms"
        isOpen={!!isNewSmsModalOpen}
        onClose={() => setIsNewSmsModalOpen(false)}
        subtitle={`Job ${job.ID}`}
        id={job.ID}
        entityType="job"
        customerTo={{ destination: job.customer?.mobile?.[0] }}
        technicianTo={{ destination: job.products?.[0]?.service_technicians?.[0]?.technician.mobile[0] }}
      />
    </>
  );
};
